/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MfaEnablePost200Response,
    MfaEnablePost200ResponseFromJSON,
    MfaEnablePost200ResponseToJSON,
    MfaEnableVerifyPost200Response,
    MfaEnableVerifyPost200ResponseFromJSON,
    MfaEnableVerifyPost200ResponseToJSON,
    MfaEnableVerifyPost400Response,
    MfaEnableVerifyPost400ResponseFromJSON,
    MfaEnableVerifyPost400ResponseToJSON,
    MfaEnableVerifyPostRequest,
    MfaEnableVerifyPostRequestFromJSON,
    MfaEnableVerifyPostRequestToJSON,
} from '../models';

export interface MfaDisablePostRequest {
    mfaEnableVerifyPostRequest: MfaEnableVerifyPostRequest;
}

export interface MfaEnableVerifyPostOperationRequest {
    mfaEnableVerifyPostRequest: MfaEnableVerifyPostRequest;
}

/**
 * 
 */
export class MFAApi extends runtime.BaseAPI {

    /**
     * Disable MFA for a user after verifying their current MFA code.
     * Disable MFA
     */
    async mfaDisablePostRaw(requestParameters: MfaDisablePostRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaEnableVerifyPost200Response>> {
        if (requestParameters.mfaEnableVerifyPostRequest === null || requestParameters.mfaEnableVerifyPostRequest === undefined) {
            throw new runtime.RequiredError('mfaEnableVerifyPostRequest','Required parameter requestParameters.mfaEnableVerifyPostRequest was null or undefined when calling mfaDisablePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mfa/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MfaEnableVerifyPostRequestToJSON(requestParameters.mfaEnableVerifyPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaEnableVerifyPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Disable MFA for a user after verifying their current MFA code.
     * Disable MFA
     */
    async mfaDisablePost(requestParameters: MfaDisablePostRequest, initOverrides?: RequestInit): Promise<MfaEnableVerifyPost200Response> {
        const response = await this.mfaDisablePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a secret and QR code for the user to scan with Google Authenticator.
     * Enable MFA - Generate secret and QR code
     */
    async mfaEnablePostRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaEnablePost200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mfa/enable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaEnablePost200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate a secret and QR code for the user to scan with Google Authenticator.
     * Enable MFA - Generate secret and QR code
     */
    async mfaEnablePost(initOverrides?: RequestInit): Promise<MfaEnablePost200Response> {
        const response = await this.mfaEnablePostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Verify the code from Google Authenticator to confirm MFA setup.
     * Verify MFA setup
     */
    async mfaEnableVerifyPostRaw(requestParameters: MfaEnableVerifyPostOperationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaEnableVerifyPost200Response>> {
        if (requestParameters.mfaEnableVerifyPostRequest === null || requestParameters.mfaEnableVerifyPostRequest === undefined) {
            throw new runtime.RequiredError('mfaEnableVerifyPostRequest','Required parameter requestParameters.mfaEnableVerifyPostRequest was null or undefined when calling mfaEnableVerifyPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mfa/enable/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MfaEnableVerifyPostRequestToJSON(requestParameters.mfaEnableVerifyPostRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaEnableVerifyPost200ResponseFromJSON(jsonValue));
    }

    /**
     * Verify the code from Google Authenticator to confirm MFA setup.
     * Verify MFA setup
     */
    async mfaEnableVerifyPost(requestParameters: MfaEnableVerifyPostOperationRequest, initOverrides?: RequestInit): Promise<MfaEnableVerifyPost200Response> {
        const response = await this.mfaEnableVerifyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a PNG QR code image for Google Authenticator setup.
     * Get MFA QR code image
     */
    async mfaQrcodeGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mfa/qrcode`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Returns a PNG QR code image for Google Authenticator setup.
     * Get MFA QR code image
     */
    async mfaQrcodeGet(initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.mfaQrcodeGetRaw(initOverrides);
        return await response.value();
    }

}
